import { Injectable } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase/app";
import { IUser } from "../shared/models/user.model";
import { ClientData } from "./client";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ENV } from "@app/env";
import { catchError, retry, switchMap, map } from "rxjs/operators";
import { Utilities } from "./utilities";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";
import { from } from "rxjs/observable/from";

@Injectable()
export class AuthData {

  public fireAuth: any;

  constructor(
    public database: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private clientData: ClientData,
    private http: HttpClient,
    private utilities: Utilities,
  ) {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.fireAuth = user;
      }
    });
  }

  public getUser() {
    return this.afAuth.authState;
  }

  public getTokenUser() {
    return this.afAuth.idToken;
  }

  public getUserData() {
    return this.fireAuth;
  }

  public getUserDB(uid: string, clientId: string) {
    return this.database.object<IUser>(`/Clients/${clientId}/Users/${uid}`).valueChanges();
  }

  public getUserBeneficiaries(clientId, userId) {
    return this.database.list<any>(`/Clients/${clientId}/Users/${userId}/UsersBeneficiaries/`).valueChanges();
  }

  public getUserGuest(clientId, userId) {
    return this.database.list<any>(`/Clients/${clientId}/Users/${userId}/UsersGuest/`).valueChanges();
  }

  public getClient(uid): Observable<any> {
    return this.getTokenUser().pipe(
      switchMap((token: string) => {
        if (!token) {
          return of([]);
        }
        const headers = new HttpHeaders({ 'Authorization': token });
        return this.http.get(`${ENV.backend}/admin/${uid}`, { headers })
          .pipe(
            switchMap((user: any) => {
              if (user) {
                return from(this.clientData.getClientConfig(user.currentClient).once("value"))
                  .pipe(
                    map((clientConfig: any) => {
                      return {
                        ...clientConfig.val(),
                        user: {
                          ...user,
                          id: uid,
                        },
                      }
                    })
                  )
              }
            })
          );
      })
    )

    // return new Promise((resolve, reject) => {
    //   firebase.database().ref(`/AdministratorList/${uid}`)
    //     .once("value")
    //     .then((user: any) => {
    //       if (user.val()) {
    //         this.clientData.getClientConfig(user.val().managerClient)
    //           .once("value")
    //           .then((clientConfig) => resolve({
    //             ...clientConfig.val(),
    //             user: {
    //               ...user.val(),
    //               id: uid,
    //             },
    //           }));
    //       } else {
    //         return reject({ message: "Not found user" });
    //       }
    //     });
    // });
  }

  public getFbUser(uid) {
    return new Promise((resolve, reject) => {
      firebase.database().ref(`/AdministratorList/${uid}`)
        .once("value")
        .then((user: any) => {
          this.clientData.getClientConfig(user.val().managerClient)
            .once("value")
            .then((clientConfig) => resolve(clientConfig.val()));
        });
    });
  }

  public loginUser(email: string, password: string): Promise<any> {
    return this.http.post(`${ENV.backend}/admin/login`, { email, password })
      .toPromise();
    // return this.afAuth.auth.signInWithEmailAndPassword(newEmail, newPassword);
  }

  public loginCustomUser(token: string): Promise<any> {
    return this.afAuth.auth.signInWithCustomToken(token);
  }

  public resetPassword(email: string): any {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  public logoutUser(): any {
    return this.afAuth.auth.signOut();
  }

  public getExactUser(uid, client) {
    return firebase.database().ref(`/Clients/${client.url}/Users/${uid}`);
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/auth.ts